/**
 * Created by RamKumar on 6/8/16.
 */

;
(function (EG, document) {

  var SUPPORTED_FORM_TYPES = ['text', 'radio', 'checkbox', 'file', 'number', 'select', 'select-one', 'hidden', 'tel', 'email','textarea'],
    DEFAULT_PARSER_KEY = "default";

  /**
   * Gets the values of all the supported inputs
   * @param  {HTMLInputElement} inputElem '<input>'
   * @return {String | Array} 'Son Goku' || '[ val1, val2, val3 ]' if multi-select
   */
  function getInputValues(inputElem) {

    var inputType = inputElem.type || _.first(inputElem).type,
      checkboxValues = [], radioValue;

    if (!inputType || !_.contains(SUPPORTED_FORM_TYPES, inputType)) {
      return;
    }

    if (inputType === 'checkbox') {
      if (!inputElem.length) {
        return inputElem.checked;
      }
      _.each(inputElem, function (elem) {
        if (elem.checked) {
          checkboxValues.push(elem.value);
        }
      });

      return checkboxValues;
    }

    if (inputType === 'radio') {
      if (!inputElem.length) {
        return inputElem.checked;
      }
      _.each(inputElem, function (elem) {
        if (elem.checked) {
          radioValue = elem.value;
        }
      });
      return radioValue;
    }

    return inputElem.value == undefined ? inputElem.value : inputElem.value.trim();
  }

  /**
   * Runs a recursion on the Model Attributes against the form inputs
   * Also invokes any parsers if available
   * @param  {Object} formProperties
   *         {
   *           attributes: {
   *             query: '',
   *             roles: []
   *           },
   *           form: 'formName',
   *           formContext: 'formContextName',
   *           parsers: {
   *             query: function(){}
   *             ...
   *           }
   *
   *         }
   * @return {Object}
   *         {
   *           query: 'Son Goku San',
   *           roles: [ val1, val2 ] // multi-select
   *         }
   */
  function parseAttributes(formProperties) {

    var formData = formProperties.twoWayBinding ? formProperties.attributes : EG.Users.Utils.deepCloneObject(formProperties.attributes),
      form = formProperties.form,
      formContext = formProperties.formContext,
      recurseAttributes = null,
      formElement = null,
      parsers = formProperties.parsers || [],
      attributeParser = null;

    recurseAttributes = function (attributes, contextName) {

      _.each(attributes, function (attribute, key) {

        var formElemValue = null;

        if (key == null) {
          return;
        }

        if (_.isObject(attributeParser) && attributeParser[key]) {
          attributeParser = attributeParser[key];
        } else {
          attributeParser = parsers[key] || parsers[DEFAULT_PARSER_KEY];
        }

        if (_.isObject(attribute)) {
          attributes[key] = recurseAttributes(attribute, contextName + '[' + key + ']');
        } else {
          formElement = form[contextName + '[' + key + ']'];

          if (formElement) {
            formElemValue = getInputValues(formElement);
            attributes[key] = attributeParser ? attributeParser({
              value: formElemValue,
              key: key,
              formElement: formElement,
              contextName: contextName
            }) : formElemValue;
          }
        }

      });

      return _.clone(attributes);

    };

    return recurseAttributes(formData, formContext);
  }

  /**
   * Parses the given form against the model for data.
   *
   * @param {Object}
   *        {
   *          formName: 'Form name to be parsed',
   *
   *          formContext: 'Context of the form elements to be scoped on',
   *
   *          attributes: {
   *            * Model for storing the parsed form values
   *            'query': 'Son Goku San',
   *            'roles': [1, 400, 500]
   *          },
   *
   *          parsers: {
   *            * Mapped against the `attributes` for extended usage before storing
   *            'query': function (result) {
   *              return 'I modified the query further, just for fun :) '
   *            }
   *          }
   *
   *        }
   *
   * @return {Object}
   *         {
   *           query: {
   *             firstname: 'Son',
   *             middlename: 'Goku',
   *             lastname: 'San'
   *           },
   *           roles: [ 'roleID' ],
   *           status: statusID,
   *           travelerGroups: [ 'tgID' ],
   *           arrangedBy: [ 'arrangerID' ],
   *           approvedBy: [ 'approverID' ]
   *         }
   */
  function parseForm(formProperties) {
    formProperties.form = document[formProperties.formName];

    if (!formProperties.form) {
      return;
    }

    formProperties.formContext = formProperties.formContext || formProperties.formName;

    return parseAttributes(formProperties);

  }

  /**
   * dateAttributeParser - Used to parse dates into ISO format
   *
   * @param formElem
   * @returns {*}
   */
  function dateAttributeParser(formElem) {
    var dateObj, formVal, format;
    if (formElem.value == undefined || formElem.value == '') {
      return undefined;
    }
    format = moment.localeData().longDateFormat('L');
    dateObj = moment(formElem.value, format);
    formVal = '';

    if (dateObj.isValid()) {
      formVal = EG.Users.Utils.getUitkDate(dateObj, {
        style: 'iso'
      });
    }
    return formVal;
  }

  /**
   * Global Exposure !
   * Uitls {Object}
   * parseForm {Function}
   */
  EG.Users.Utils.parseForm = parseForm;
  EG.Users.Utils.dateAttributeParser = dateAttributeParser;

})(EG, document);
